export const getThemeJson = (customStyle, companySlug) => {
  const customFont = customStyle.fontFamily;
  return {
    palette: {
      primary: {
        main: customStyle.themePrimaryColor || "#08558b",
        contrastText: customStyle.themePrimaryTextColor || "#fff",
      },
      secondary: {
        main: customStyle.themeSecondaryColor || "#08558b",
        contrastText: customStyle.themeSecondaryTextColor || "#fff",
      },
    },
    typography: customFont
      ? {
          fontFamily: customFont,
          h1: { fontFamily: customFont },
          h2: { fontFamily: customFont },
          h3: { fontFamily: customFont },
          h4: { fontFamily: customFont },
          h5: { fontFamily: customFont },
          h6: { fontFamily: customFont },
          subtitle1: { fontFamily: customFont },
          subtitle2: { fontFamily: customFont },
          body1: { fontFamily: customFont },
          body2: { fontFamily: customFont },
          button: { fontFamily: customFont },
          caption: { fontFamily: customFont },
          overline: { fontFamily: customFont },
        }
      : {},
    overrides: {
      MuiButton: {
        containedPrimary: {
          color: customStyle.themePrimaryTextColor || "#fff",
          "&:hover": {
            backgroundColor: customStyle.themePrimaryColor + "dd" || "#08558b",
          },
        },
      },
      MuiSlider: {
        thumb: {
          color: customStyle.themePrimaryColor || "#08558b",
        },
        track: {
          color: customStyle.themePrimaryColor || "#08558b",
        },
        markLabelActive: {
          fontWeight: "lighter",
        },
      },
      MuiInputBase: {
        input: {
          background: "#fff",
        },
        root: {
          background: "#fff",
        },
      },
    },
  };
};
